module.exports = __webpack_public_path__ + "images/ui-icons_228ef1_256x240.png";